// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2zZy2","title":"FrontImage_title__3vHQU"};